import * as React from "react";
import {RenewalPreferences} from "../enums/enums";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {AutoRenewalBenefits} from "@falcon/plugin-falcon-journey";

interface IAutoRenewalQuestionProps {
    onSave: (automaticRenewal: boolean) => void;
}
interface IAutoRenewalQuestionState {
    isOpen: boolean;
    automaticRenewal?: boolean;
    showSuccessModal: boolean;
}

export class AutoRenewalQuestionModal extends React.Component<IAutoRenewalQuestionProps, IAutoRenewalQuestionState> {

    constructor(props: IAutoRenewalQuestionProps) {
        super(props);

        this.state = {
            isOpen: true,
            automaticRenewal: undefined,
            showSuccessModal: false,
        };
    }

    public render() {
        return (
            <>
                {<Modal className="my-2 manual-renewal-modal" isOpen={this.state.isOpen} toggle={this.hideModal}>
                    <ModalHeader close={<button className="btn-close" onClick={this.hideModal}/>}/>
                    <ModalBody className={`pt-0 `}>

                            <h1 className="a-bold fs-20">Your policy is renewed. Why not make it easier for the future?</h1>
                            <h2 className="font-family-base font-weight-semi-bold text-blue-2 fs-16 margin-top-32">Why auto-renew?</h2>
                            <AutoRenewalBenefits/>
                            <h2 className="padding-bottom-16 font-weight-semi-bold">Do you want your annual car policy to auto-renew every year?</h2>
                            <div className="input-group">
                                <div className="custom-control w-100">
                                    <input
                                        className={"custom-radiobutton cursor-pointer"}
                                        type="radio"
                                        name={"performRenewal-" + RenewalPreferences.RENEWAL_THIS_YEAR}
                                        id={"performRenewal-" + RenewalPreferences.RENEWAL_THIS_YEAR}
                                        value={"false"}
                                        checked={this.state.automaticRenewal === false}
                                        onChange={this.changeAutomaticRenewal}
                                    />
                                    <label id={'driver-label'} className="checkbox-label label-bg-transparent font-weight-semi-bold"
                                           htmlFor={"performRenewal-" + RenewalPreferences.RENEWAL_THIS_YEAR}>
                                        Renew this year only
                                    </label>
                                </div>
                                <div className="custom-control w-100">
                                    <input
                                        className={"custom-radiobutton cursor-pointer"}
                                        type="radio"
                                        name={"performRenewal-" + RenewalPreferences.RENEWAL_EVERY_YEAR}
                                        id={"performRenewal-" + RenewalPreferences.RENEWAL_EVERY_YEAR}
                                        value={"true"}
                                        checked={this.state.automaticRenewal === true}
                                        onChange={this.changeAutomaticRenewal}
                                    />
                                    <label id={'driver-label'} className="checkbox-label label-bg-transparent font-weight-semi-bold"
                                           htmlFor={"performRenewal-" + RenewalPreferences.RENEWAL_EVERY_YEAR}>
                                        Auto-renew every year
                                    </label>
                                </div>
                            </div>
                        </ModalBody>
                    <ModalFooter>
                        <div className="d-flex flex-column w-100">
                            <button type="button"
                                    className="btn btn-primary btn-blue-dashboard m-auto"
                                    onClick={this.updateAutomaticRenewal}
                                    id="updateAutomaticRenewal"
                                    disabled={this.state.automaticRenewal === undefined}
                            >
                                Save changes
                            </button>
                            <button type="button"
                                    className="btn btn-white-dashboard"
                                    onClick={this.hideModal}
                                    id="cancelChanges">
                                Cancel changes
                            </button>
                        </div>

                    </ModalFooter>
                </Modal>
                }
            </>
        );
    }

    private updateAutomaticRenewal = (): void => {
        this.props.onSave(this.state.automaticRenewal!);
        this.hideModal();
    }

    private hideModal = (): void => {
        this.setState({
            isOpen: false
        });
    }

    private changeAutomaticRenewal = (event: any) => {
        const value: boolean = event.target.value === "true";
        this.setState({
            automaticRenewal: value
        })
    }
}



// WEBPACK FOOTER //
// ./src/components/modals/AutoRenewalQuestionModal.tsx